"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uiReducer = void 0;
const ui_1 = require("../actions/ui");
const DEFAULT_RESULT_SIZE = 12;
const initState = {
    loading: true,
    outdatedCount: 0,
    resultsCount: { from: 0, size: DEFAULT_RESULT_SIZE },
    pending: [],
    searchAgentAuthentication: false,
    anchorNavigationHideItemOnDetailPage: [],
    resultsViewType: '',
    showDistance: false,
};
const uiReducer = (ui = initState, action) => {
    switch (true) {
        case action.type.includes(ui_1.SET_SHOW_DISTANCE):
            return Object.assign(Object.assign({}, ui), { showDistance: action.payload });
        case action.type.includes(ui_1.SET_RESULTS_VIEW_TYPE):
            return Object.assign(Object.assign({}, ui), { resultsViewType: action.payload });
        case action.type.includes(ui_1.SET_SEARCH_AGENT_AUTHENTICATION):
            return Object.assign(Object.assign({}, ui), { searchAgentAuthentication: action.payload });
        case action.type.includes(ui_1.SET_LOADER):
            return Object.assign(Object.assign({}, ui), { loading: action.payload });
        case action.type.includes(ui_1.SET_OUTDATEDCOUNT):
            return Object.assign(Object.assign({}, ui), { outdatedCount: action.payload });
        case action.type.includes(ui_1.SET_PENDING):
            return Object.assign(Object.assign({}, ui), { pending: [...new Set([...ui.pending, action.payload])] });
        case action.type.includes(ui_1.REMOVE_PENDING):
            const pending = ui.pending.filter((id) => id !== action.payload);
            return Object.assign(Object.assign({}, ui), { pending });
        case action.type.includes(ui_1.INCREMENT_RESULTS_COUNT):
            return Object.assign(Object.assign({}, ui), { resultsCount: {
                    from: ui.resultsCount.from + DEFAULT_RESULT_SIZE,
                    size: DEFAULT_RESULT_SIZE,
                } });
        case action.type.includes(ui_1.RESET_RESULTS_COUNT):
            return Object.assign(Object.assign({}, ui), { resultsCount: { from: 0, size: DEFAULT_RESULT_SIZE } });
        case action.type.includes(ui_1.SET_ANCHOR_NAVIGATION_HIDE_ITEM_ON_DETAIL_PAGE):
            return Object.assign(Object.assign({}, ui), { anchorNavigationHideItemOnDetailPage: [
                    ...new Set([...ui.anchorNavigationHideItemOnDetailPage, action.payload]),
                ] });
        case action.type.includes(ui_1.DELETE_ANCHOR_NAVIGATION_HIDE_ITEM_ON_DETAIL_PAGE):
            return Object.assign(Object.assign({}, ui), { anchorNavigationHideItemOnDetailPage: action.payload });
        default:
            return ui;
    }
};
exports.uiReducer = uiReducer;
//# sourceMappingURL=ui.reducer.js.map